import { AuthProvider } from './AuthProvider';

/**
 * Server component wrapper for AuthProvider.
 * Better Auth works locally without external dependencies.
 */
export function AuthProviderWrapper({ children }: { children: React.ReactNode }) {
  return <AuthProvider>{children}</AuthProvider>;
}
